import React from 'react';

import { View, Image, ActivityIndicator, StyleSheet, Pressable, Platform } from 'react-native';

import OPComponent from '../op_component';
import Navigation from '../../../navigation';
import Utils from '../../../utils';

import { COLOR } from '../../../constants/styles';

export const IMAGE_WIDTH = 250.0;
export const IMAGE_HEIGHT = 150.0;

export default class VideoView extends OPComponent {
  constructor(props) {
    super(props);

    this.unMounted = true;

    this.state = {
      loading: (!props.imageUri && props.loading) || null,
      imageUri: props.imageUri || null,
      thumbnailUri: null,
      imageError: false,
      controls: false,
      fullscreen: false,
      paused: true,
    };
  }

  componentDidMount() {
    this.unMounted = false;
  }
  componentWillUnmount() {
    this.unMounted = true;
  }

  componentDidUpdate(prevProps) {
    if (this.props.loading !== prevProps.loading || this.props.imageUri !== prevProps.imageUri) {
      this.setState({
        loading: this.props.loading,
        imageUri: this.props.imageUri,
      });
    }
  }

  setImageUri(imageUri) {
    imageUri = this.fixupImageUri(imageUri);

    Utils.createThumbnail(imageUri)
      .then((result) => {
        this.setState({ imageUri, thumbnailUri: result.path, loading: false });
      })
      .catch((e) => {
        this.setState({ imageUri, thumbnailUri: imageUri, loading: false });
      });
  }

  fixupImageUri(imageUri) {
    if (!imageUri) return imageUri;

    // web has :// for http:// but doesn't need to have file:/// appended
    if (Platform.OS !== 'web' && imageUri.indexOf('://') === -1) {
      imageUri = `file:///${imageUri}`;
    }
    return imageUri;
  }

  handlePress = () => {
    if (this.props.onPress) {
      this.props.onPress();
    } else {
      let { imageUri } = this.state;

      Navigation.showModal({
        screen: 'FullScreenVideo',
        title: '',
        passProps: {
          imageUri,
        },
      });
    }
  };
  render() {
    const { width, height, spinnerColor, flexSize, onImageError, onSwipeHorizontal } = this.props;
    let { loading, imageUri, thumbnailUri } = this.state;

    const sizeStyle = {
      width: width || IMAGE_WIDTH,
      height: height || IMAGE_HEIGHT,
    };

    if (loading) {
      return (
        <View style={[styles.imageContainer, styles.activityContainer, sizeStyle]}>
          <ActivityIndicator animating={true} size="large" color={spinnerColor || 'black'} />
        </View>
      );
    }

    const playIconStyle = {
      top: (sizeStyle?.height || 90) / 2 - 24,
      left: (sizeStyle?.width || 230) / 2 - 24,
    };

    if (this.state.imageError || !imageUri) {
      return (
        <Pressable style={[styles.imageContainer, sizeStyle]} onPress={this.handlePress}>
          <Image
            style={styles.imageMissingIcon}
            source={require('../../../../resources/icon-no-image.png')}
          />
          <Image
            style={[styles.playIcon, playIconStyle]}
            source={require('../../../../resources/icon-play.png')}
          />
        </Pressable>
      );
    }

    return (
      <Pressable style={[styles.imageContainer, sizeStyle]} onPress={this.handlePress}>
        <Image
          style={[styles.messageImage, sizeStyle]}
          source={{ uri: thumbnailUri }}
          resizeMode={this.props.resizeMode || 'cover'}
          onError={(e) => {
            if (!this.unMounted) this.setState({ imageError: true });
            onImageError && onImageError(e);
          }}
        />
        <Image
          style={[styles.playIcon, playIconStyle]}
          source={require('../../../../resources/icon-play.png')}
        />
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  messageImage: {
    //borderRadius: 15,
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  imageContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  imageMissingIcon: {
    tintColor: COLOR.accent,
  },
  activityContainer: {
    paddingTop: 4,
    paddingLeft: 4,
  },
  playIcon: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
});
